<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CHeaderBrand class="d-lg-none" to="/Wof">
          <img
            src="img/arrow.png"
            width="60"
            style="padding-left:15px; padding-right:10px;"
          />
          <h3 style="padding-left: 12px;">
            <b
              ><font color="gray">{{ this.resultSummary.WorkOrderNo }}</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <img
            src="img/arrow.png"
            @click="backClick()"
            width="65"
            style="padding-left:15px; padding-right:10px;"
          />
          <h2>
            <b>
              <font color="gray">{{ this.resultSummary.WorkOrderNo }}</font></b
            >
          </h2>
          <input type="hidden" v-bind:Oid="Oid" />
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main amsys-approval-main">
          <CContainer fluid class="amsys-det-app-container">
            <transition name="fade" mode="out-in">
              <div>
                <CRow>
                  <CCol sm="12" class="amsys-det-app-col">
                    <transition name="fade">
                      <CCard v-if="show" class="amsys-det-app-card">
                        <CCardBody class="amsys-det-app-cardBody">
                          <CTabs class="amsys-det-app-tabs">
                            <CTab
                              title="SUMMARY"
                              active
                              class="amsys-det-app-tab"
                            >
                              <table class="table amsys-approval-table-14">
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Created Date</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.CreatedDate }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Date</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.Date }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Issuer</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.Issuer }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Company</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.Company }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Equipment</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.Equipment }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Purpose Code</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.PurposeCode }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Problem</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.Problem }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>HM</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.HM }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>DownTime</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.DownTime }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Start Working Time</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.StartWorkingTime }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="amsys-det-app-td1" width="30%">
                                      <b>Ready Time</b>
                                    </td>
                                    <td class="amsys-det-app-td1" colspan="2">
                                      {{ this.resultSummary.ReadyTime }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table class="table" style="border: 0;">
                                <tr style="border: 0;">
                                  <td
                                    style="padding: 0.3rem;border: 0;"
                                    width="100%"
                                  >
                                    <CButton
                                      color="info"
                                      @click="approve(1)"
                                      style="width: 100%;font-size: 14px;"
                                      >Finish</CButton
                                    >
                                  </td>
                                  <td
                                    style="padding: 0.3rem;border: 0;"
                                    width="50%"
                                  >
                                    <!--<CButton color="danger" @click="approve(2)" style="width: 100%;font-size: 14px;">Reject</CButton>-->
                                  </td>
                                </tr>
                              </table>
                            </CTab>
                            <CTab title="DETAILS" class="amsys-det-app-tab">
                              <table class="table amsys-approval-table-14">
                                <tr>
                                  <th colspan="3">Task Details</th>
                                </tr>
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1">
                                      Description
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      JobList No
                                    </td>
                                    <td class="amsys-det-app-td1">Start</td>
                                    <td class="amsys-det-app-td1">Finish</td>
                                  </tr>
                                  <tr v-for="item in this.resultDetail">
                                    <td class="amsys-det-app-td1">
                                      {{ item.Description }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.JobListNo }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Start }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Finish }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <br />
                              <table class="table amsys-approval-table-14">
                                <tr>
                                  <th colspan="3">Material Requests</th>
                                </tr>
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1">Code</td>
                                    <td class="amsys-det-app-td1">Item</td>
                                    <td class="amsys-det-app-td1">qty</td>
                                    <td class="amsys-det-app-td1">
                                      Estimate Supply
                                    </td>
                                  </tr>
                                  <tr v-for="item in resultMaterialRequest">
                                    <td class="amsys-det-app-td1">
                                      {{ item.PartCode }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Item }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.qty }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.EstimateSupply }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <br />
                              <table class="table amsys-approval-table-14">
                                <tr>
                                  <th colspan="2">Additional Task</th>
                                </tr>
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1">No</td>
                                    <td class="amsys-det-app-td1">
                                      Task Description
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      Special Instruction
                                    </td>
                                  </tr>
                                  <tr v-for="item in resultAdditionalTask">
                                    <td class="amsys-det-app-td1">
                                      {{ item.No }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.TaskDescription }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.SpecialInstruction }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <br />
                              <table class="table amsys-approval-table-14">
                                <tr>
                                  <th colspan="3">Additional Parts</th>
                                </tr>
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1">Code</td>
                                    <td class="amsys-det-app-td1">Item</td>
                                    <td class="amsys-det-app-td1">qty</td>
                                    <td class="amsys-det-app-td1">
                                      RequiredDate
                                    </td>
                                  </tr>
                                  <tr v-for="item in resultAdditionalParts">
                                    <td class="amsys-det-app-td1">
                                      {{ item.PartCode }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Item }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Qty }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.RequiredDate }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <br />
                              <table class="table amsys-approval-table-14">
                                <tr>
                                  <th colspan="4">Material Request Cancel</th>
                                </tr>
                                <tbody>
                                  <tr>
                                    <td class="amsys-det-app-td1">Code</td>
                                    <td class="amsys-det-app-td1">Item</td>
                                    <td class="amsys-det-app-td1">qty</td>
                                    <td class="amsys-det-app-td1">Reason</td>
                                    <td class="amsys-det-app-td1">Date</td>
                                  </tr>
                                  <tr
                                    v-for="item in resultMaterialRequestCancel"
                                  >
                                    <td class="amsys-det-app-td1">
                                      {{ item.PartCode }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Item }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Qty }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.Reason }}
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.CancelDate }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </CTab>
                            <CTab title="APPROVERS" class="amsys-det-app-tab">
                              <table class="table amsys-approval-table-14">
                                <tbody>
                                  <tr v-for="item in approvers">
                                    <td class="amsys-det-app-td3">
                                      <div class="c-avatar">
                                        <img
                                          class="c-avatar-img"
                                          src="img/no-photo.jpg"
                                        />
                                      </div>
                                    </td>
                                    <td class="amsys-det-app-td4">
                                      {{ item.Approver }} <br />
                                      <font
                                        color="orange"
                                        v-if="item.Status === 'Pending'"
                                      >
                                        {{ item.Status }}
                                      </font>
                                      <font color="green" v-else>
                                        {{ item.Status }}
                                      </font>
                                    </td>
                                    <td class="amsys-det-app-td1">
                                      {{ item.ApprovalDate }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </CTab>
                          </CTabs>
                        </CCardBody>
                      </CCard>
                    </transition>
                  </CCol>
                </CRow>
              </div>
            </transition>
          </CContainer>
        </main>
      </div>
      <CRow class="justify-content-center">
        <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
      </CRow>
      <CRow class="justify-content-center">
        <div
          id="loading-contentx"
          v-if="loading"
          style="margin-bottom: 20%;"
        ></div>
      </CRow>
    </CWrapper>
    <CModal
      size="sm"
      :show.sync="modalChangeBA"
      color="info"
      style="font-size: 14px;"
    >
      <font style="font-size: 14px; width: 80%;"
        ><b>Current Budget : {{ BudgetName }}</b></font
      >
      <br />
      <br />
      <select class="form-control" style="font-size: 14px;" v-model="selected">
        <!--<option value="0" disabled selected>
                    Select Budget Account
                </option>-->
        <option v-for="item in listBudget" :value="item.Oid" :key="item.Oid">
          {{ item.BudgetAccount }}
        </option>
      </select>
      <template #footer>
        <CButton
          @click="modalChangeBA = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
        <CButton
          @click="actionModalCBA()"
          style="font-size: 14px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      :show.sync="modalOverBudget"
      color="info"
      style="font-size: 14px;"
    >
      <font style="font-size: 14px; width: 80%;"
        ><b>BUDGET EXCESS REASON</b></font
      >
      <br />
      <br />
      <textarea
        style="font-size: 14px;"
        class="form-control"
        v-model="BudgetExcessReason"
        name="textarea-input"
        rows="5"
        placeholder="Budget Excess Reason.."
      >
      </textarea>
      <template #footer>
        <CButton
          @click="modalOverBudget = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
        <CButton
          @click="actionModalOverBudget()"
          style="font-size: 14px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      :show.sync="modalNote"
      color="info"
      style="font-size: 14px;"
    >
      <font style="font-size: 14px; width: 80%;"><b>NOTES</b></font>
      <br />
      <br />
      <textarea
        style="font-size: 14px;"
        class="form-control"
        v-model="Notes"
        name="textarea-input"
        rows="5"
        placeholder="Notes.."
      >
      </textarea>
      <template #footer>
        <CButton
          @click="modalNote = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
        <CButton
          @click="actionModalNote()"
          style="font-size: 14px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  name: "WorkOrderDetail",
  components: {},
  data() {
    return {
      result: [],
      details: [],
      approvers: [],
      comments: [],
      formComment: [],
      listBudget: [],
      attachment: [],
      addApprovers: [],
      budget: [],
      resultSummary: [],
      resultDetail: [],
      resultMaterialRequest: [],
      resultAdditionalTask: [],
      resultAdditionalParts: [],
      resultMaterialRequestCancel: [],

      selected: "",
      selectedApprover: "",
      show_input: false,
      modalOverBudget: false,
      modalNote: false,
      modalChangeBA: false,
      modalAddApprovers: false,
      modalBudget: false,

      Oid: "",
      Name: "",
      CompanyID: "",
      Company: "",
      DepartmentID: "",
      Department: "",
      Dates: "",
      Reference: "",
      Purpose: "",
      TotalAmount: "0",
      Amount: "0",
      OverBudget: "0",
      Currency: "",
      Notes: "",
      BudgetExcessReason: "",
      BudgetAccount: "",
      BudgetName: "",
      CreatedDate: "",
      Comment: "",
      show: true,
      render: true,
      number: this.$route.query.number,
      isCollapsed: false,
      loading: true,
      notif: false,
      approveStatus: "0",

      urlServer: "",
    };
  },
  methods: {
    backClick() {
      this.$router.push({ path: "Wof" });
    },
    SendNotification(no, notif) {
      let formData = {
        app_id: "3f8b7bb1-c4e1-41d2-85dd-37ce37cbd4f1",
        included_segments: ["Subscribed Users"],
        headings: { en: no },
        contents: { en: notif },
      };
      var data = "NGY1M2VlOGQtNDY3Yi00ZTFiLThjZDQtNDAzOTQ0ZDE1YmYz";
      axios
        .post("https://onesignal.com/api/v1/notifications", formData, {
          headers: {
            "content-type": "application/json;",
            authorization: "Basic " + data,
          },
        })
        .then((res) => {
          this.resultLoading = res;
          console.log(this.resultLoading);
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
          });
        });
    },
    showModalNote() {
      this.modalNote = true;
    },
    showModalAddApprovers() {
      this.modalAddApprovers = true;
      this.GetAddApprovers();
    },
    async approve(status) {
      this.approveStatus = status;
      if (status === 2) {
        this.modalNote = true;
      } else {
        this.PostApprovalStatus(1);
      }
    },
    async actionModalNote() {
      this.PostApprovalStatus(2);
    },
    async PostApprovalStatus(status) {
      this.loading = true;
      let data = localStorage.token;
      let user = localStorage.user;
      let no = this.resultSummary.WorkOrderNo;

      if (status == 2 && this.Notes == "") {
        this.loading = false;
        Vue.$toast.open({
          message: "Notes not null !",
          type: "warning",
          position: "bottom",
        });
      } else {
        let Oid = this.resultSummary.Oid;
        let message = "";
        let messageNotif = "";
        if (status == 1) {
          message = "data has been approved";
          messageNotif = no + "- has been approved finish by " + user;
        } else {
          message = "data has been rejected";
          messageNotif = no + "- has been rejected finish by " + user;
        }
        const form = new FormData();
        form.append("Oid", Oid);
        let sendData = JSON.stringify(Object.fromEntries(form));
        await axios
          .post(
            `${this.urlServer}/Api/Approval/PostApprovalWOFinish/`,
            sendData,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            }
          )
          .then((res) => {
            this.SendNotification(no, messageNotif);
            this.modalNote = false;
            this.loading = false;
            Vue.$toast.open({
              message: message,
              type: "success",
              position: "bottom",
            });
            this.$router.go(-1);
          })
          .catch((error) => {
            this.loading = false;
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          });
      }
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    let data = localStorage.token;
    this.Oid = this.$route.query.id;
    if (typeof data != "undefined") {
      // Get
      const param = { Oid: this.$route.query.id };
      const paramTrans = { TransID: this.$route.query.id };
      const paramComment = { RecordOid: this.$route.query.id };
      //Work Order
      axios
        .post(`${urlS}/Api/Approval/GetWorkOrderByID/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.resultSummary = res.data[0];
        })
        .catch((error) => {
          console.error(error);
        });

      // Details
      axios
        .post(`${urlS}/Api/Approval/GetWorkOrderTaskDetailsByID/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.resultDetail = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      // MaterialRequest
      axios
        .post(
          `${urlS}/Api/Approval/GetWorkOrderMaterialRequestDetailsByID/`,
          param,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.resultMaterialRequest = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      // AdditionalTask
      axios
        .post(`${urlS}/Api/Approval/GetWorkOrderAdditionalTaskByID/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.resultAdditionalTask = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      // AdditionalParts
      axios
        .post(`${urlS}/Api/Approval/GetWorkOrderAdditionalPartsByID/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.resultAdditionalParts = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      // MaterialRequestCancel
      axios
        .post(
          `${urlS}/Api/Approval/GetWorkOrderMaterialRequestCancelByID/`,
          param,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.resultMaterialRequestCancel = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      //Consignment  Stock Order Details
      axios
        .post(
          `${urlS}/Api/Approval/GetConsignmentStockOrderDetailByID/`,
          param,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          }
        )
        .then((res) => {
          this.details = res.data;
          console.log(this.details);
        })
        .catch((error) => {
          console.error(error);
        });

      //Consignment  Stock Order Approvers
      axios
        .post(`${urlS}/Api/Approval/ShowListofApprovers/`, paramTrans, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.approvers = res.data;
          console.log(this.approvers);
        })
        .catch((error) => {
          console.error(error);
        });

      //Consignment  Stock Order Comments
      axios
        .post(`${urlS}/Api/Comment/GetComments/`, paramComment, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          let result = res.data;
          result.sort(function(a, b) {
            return a.CommentDateTime.localeCompare(b.CommentDateTime);
          });

          this.comments = result;
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    } else {
      this.loading = false;
      Vue.$toast.open({
        message: "You don't have permission",
        type: "error",
        position: "bottom",
      });
      this.$router.push({ path: "/pages/login" });
    }
  },
};
</script>
